import { gql } from '@apollo/client';

export const GET_STAY_INFORMATION_COLLECTION_QUERY = gql`
  fragment CommonStayInformationFieldsForCollection on StayInformation {
    id
    bannerImage {
      id
      url
      formats
    }
    title
    locale
    hidden
    size
    externalBannerImage
  }

  query GetStayInformationCollection($hotelId: ID!) {
    hotel(id: $hotelId) {
      id
      stayInformationBannerImage {
        id
        url
        formats
      }
      stayInformations(where: { parentStayInfo_null: true }) {
        appSortOrder
        ...CommonStayInformationFieldsForCollection
        localizations {
          ...CommonStayInformationFieldsForCollection
        }
      }
    }
  }
`;
